import { render } from "./AddTrainProject.vue?vue&type=template&id=2b698d46"
import script from "./AddTrainProject.vue?vue&type=script&lang=js"
export * from "./AddTrainProject.vue?vue&type=script&lang=js"
script.render = render

export default script